// Module
var code = "<template> <require from=\"app/core/components/summary/job/job-detail-summary\"></require> <job-detail-summary import-job-id.bind=\"importJobStagedJobIdentifier\" import-job-system-code.bind=\"importJobStagedSystemCode\"></job-detail-summary> </template> ";
// Exports
module.exports = code;